import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {CourseList} from './elements';
import {Loader} from "../../../../../common/elements";
import {PrismicDocumentHelper} from '../../../../../../helpers/prismicHelpers/PrismicHelpers';
import { PaginationComponent } from "../../../../../common/elements/PaginationComponent";
import ThemePageBanner from '../../../../../dashboardNew/components/ThemePageBanner';
import {CoursesListHelper} from "../../../../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers";

class CoursesPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        loading: true,
        courses: [],
        pageData: '',
        pagination: null,
        pageNumber: null
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        this.getCourses();
    }

    async getCourses() {
        const {
            page
        } = this.props.location.query;
        const pageNumber = page ? page : 1
        try {
            const data = await PrismicDocumentHelper('document.type', 'my-courses', false, 'at')
            this.setState({pageData: data.result[0].data});
            let courseIds = [];
            data.result[0].data.courses.map(course =>  { courseIds.push(course.individual_course.id) })

            const courseData = await PrismicDocumentHelper('document.id', courseIds , false, 'in', pageNumber )
            let courses = CoursesListHelper(courseData);
            this.setState({
                loading: false,
                courses,
                pagination: {
                    page: courseData.pageDetails.page,
                    results_per_page: courseData.pageDetails.results_per_page,
                    total_pages: courseData.pageDetails.total_pages,
                    results_size: courseData.pageDetails.results_size,
                    total_results_size: courseData.pageDetails.total_results_size
                },
                pageNumber
            });
        } catch (err) {
            this.setState({ 
                loading: false,
                error: true
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.query !== prevProps.location.query) {
            this.setState({
                loading:true
            })
            this.getCourses()
        }
    }

    handlePageChange = (e) => {
        window.scrollTo(0,0);
        this.props.router.push(`/training/courses?page=${e}`)
    }

    render() {
        const {
            loading,
            courses,
            pagination,
            error
        } = this.state;
      
        if (!courses || loading) return <Loader/>;

        if (error) return (
            <div className="container margin-top margin-bottom">
                <h1 className="h1">Something went wrong, please try again.</h1>
            </div>
        )

        return (
            <article className="courses-body">
                <ThemePageBanner
                    heading={this.state.pageData.courses_page_title}
                    image='/images/learning-hub-new.jpg'
                />
                <div className="container theme-page-content-wrapper">
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">{this.state.pageData.page_summary}</p>
                        </div>
                    </div>

                    <CourseList courses={this.state.courses}/>

                </div>
                        <React.Fragment>
                            <div className="hidden-xs">
                                <PaginationComponent
                                    activePage={pagination.page}
                                    itemsCountPerPage={pagination.results_per_page}
                                    totalItemsCount={pagination.total_results_size}
                                    pageRangeDisplayed={3}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                            <div className="hidden-sm hidden-md hidden-lg">
                                <PaginationComponent
                                    activePage={pagination.page}
                                    itemsCountPerPage={pagination.results_per_page}
                                    totalItemsCount={pagination.total_results_size}
                                    pageRangeDisplayed={1}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                        </React.Fragment>
            </article>
        );
    };
};

export default withRouter(CoursesPage);


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/CoursesPage.js